<template>
  <Button
    :disabled="disabled"
    data-bs-toggle="modal"
    data-bs-target="#create-project"
  >
    Create
  </Button>

  <div
    class="modal fade"
    id="create-project"
    tabindex="-1"
    aria-labelledby="create-project-label"
    aria-hidden="true"
    ref="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="create-project-label">Create new Project</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div class="modal-body">
          <form @submit.prevent="createProject">
            <div class="mb-3">
              <label for="project-name" class="col-form-label">Project name:</label>
              <input
                type="text" class="form-control" id="project-name" required
                v-model="projectName"
              >
            </div>
            <div class="mb-3">
              <label for="project-description" class="col-form-label">Project description:</label>
              <textarea
                row="3"
                type="text" class="form-control" id="project-description"
                v-model="projectDescription"
              />
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <Button
            data-bs-dismiss="modal"
            :disabled="creating"
            :dynamicAttrs="{
              class: 'white'
            }"
          >
            Cancel
          </Button>
          <Button
            :disabled="creating"
            @click="createProject"
            :dynamicAttrs="{
              loading: creating
            }"
          >
            Create
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Button from '@/components/Button/template.vue';
import { Modal } from 'bootstrap';
import { projectsMapper } from '../store';

export default defineComponent({
  name: 'CreateProjectButton',
  components: {
    Button,
  },
  props: {
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      creating: false,
      projectName: '',
      projectDescription: '',
    };
  },
  methods: {
    ...projectsMapper.mapActions(['create']),
    async createProject(): Promise<void> {
      if (!this.projectName || this.creating) {
        return;
      }
      this.creating = true;
      await this.create({ name: this.projectName, description: this.projectDescription });
      this.projectName = '';
      this.projectDescription = '';
      this.creating = false;
      Modal.getInstance(this.$refs.modal as Element).hide();
    },
  },
});
</script>
